import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { blogInteractionService } from '../../../services/blogInteractionService';
import { useAuth } from '../../../contexts/AuthContext';

const BlogInteractions = ({ blogId, initialCounts = { views: 0, likes: 0, shares: 0 } }) => {
  const [counts, setCounts] = useState(initialCounts);
  const [isLiked, setIsLiked] = useState(false);
  const [error, setError] = useState(null);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const data = await blogInteractionService.getInteractionCounts(blogId);
        setCounts(data);
      } catch (error) {
        console.error('Error fetching interaction counts:', error);
      }
    };

    fetchCounts();
  }, [blogId]);

  const handleLike = async () => {
    try {
      if (!isAuthenticated) {
        navigate('/login', { state: { from: window.location.pathname } });
        return;
      }

      await blogInteractionService.trackLike(blogId);
      setCounts(prev => ({ ...prev, likes: prev.likes + 1 }));
      setIsLiked(true);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleShare = async () => {
    try {
      await blogInteractionService.trackShare(blogId);
      setCounts(prev => ({ ...prev, shares: prev.shares + 1 }));
      
      // Share functionality
      if (navigator.share) {
        await navigator.share({
          title: document.title,
          url: window.location.href
        });
      } else {
        // Fallback for browsers that don't support Web Share API
        navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  return (
    <div className="flex items-center space-x-6 text-gray-600">
      <div className="flex items-center">
        <span className="mr-1">👁️</span>
        <span>{counts.views}</span>
      </div>
      
      <button
        onClick={handleLike}
        className={`flex items-center ${isLiked ? 'text-red-500' : 'hover:text-red-500'}`}
        title={isAuthenticated ? 'Like this post' : 'Login to like this post'}
      >
        <span className="mr-1">❤️</span>
        <span>{counts.likes}</span>
      </button>
      
      <button
        onClick={handleShare}
        className="flex items-center hover:text-blue-500"
        title="Share this post"
      >
        <span className="mr-1">📤</span>
        <span>{counts.shares}</span>
      </button>

      {error && (
        <div className="text-red-500 text-sm">{error}</div>
      )}
    </div>
  );
};

export default BlogInteractions; 